import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import {
  CoreModal,
  useToggle,
  CorePage,
  CorePageTitle,
  PageableFilterSearchTable,
  ResourceFilter,
} from '@amzn/dots-core-ui';

import Row from '@amzn/meridian/row';
import Tooltip from '@amzn/meridian/tooltip';
import Button from '@amzn/meridian/button';
import { PlanForm } from './PlanForm';
import { Plan, useClient } from '../../api';
import PlanColumnDefinitions from './PlanColumnDefinitions';

const filters: ResourceFilter[] = [
  { key: '_name', label: 'Name', type: 'contains', isDefault: true },
  { key: 'description', label: 'Description', type: 'contains' },
  { key: 'owner', label: 'Owner', type: 'equals' },
  { key: 'createdBy', label: 'Created By', type: 'equals' },
];

function PlanList(): JSX.Element {
  const history = useHistory();
  const { path } = useRouteMatch();
  const [isModalOpen, closeModal, openModal] = useToggle();
  const { tmsClient } = useClient();

  return (
    <>
      <CoreModal
        title="Add a New Plan"
        isOpen={isModalOpen}
        onClose={closeModal}
      >
        <PlanForm
          onCancel={closeModal}
          onSubmit={async (newPlan): Promise<void> => {
            const result = await tmsClient.plans.create(newPlan);
            history.push(`${path}/${result.id}/suites`);
          }}
        />
      </CoreModal>
      <CorePage
        title="Test Plans"
        header={
          <Row widths="fill">
            <CorePageTitle title="Test Plans" />
          </Row>
        }
      >
        <PageableFilterSearchTable
          actions={
            <Row alignmentHorizontal="end">
              <Tooltip title="Add New" position="bottom">
                <Button onClick={openModal}>Add New</Button>
              </Tooltip>
            </Row>
          }
          resourceKey={tmsClient.plans.resourceKey}
          getAll={tmsClient.plans.getAll}
          resourceFilters={filters}
          preSetParams={{ fuzzySearch: false }}
          columns={PlanColumnDefinitions}
          onRowClick={(item: Plan): void =>
            history.push(`${path}/${item.id}/suites`)
          }
        />
      </CorePage>
    </>
  );
}

export default PlanList;
